import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import UploadDocument from 'modules/documents/components/UploadDocument';
import MandatoryField from 'modules/_shared/components/MandatoryField';
import InputTextArea from 'modules/_shared/components/InputTextArea';

import { useContributionModal } from '../context/ContributionModalContext';

const ContributionModalScriptureView: FC = () => {
  const { t } = useTranslate();

  const MAX_DATE = '2100-01-01';
  const MAX_COMMENT_LENGTH = 3000;

  const { data, actions } = useContributionModal();
  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="contribution-date">
          {t('Date')} <MandatoryField />
        </label>
        <div className="form-control-wrap">
          <input
            id="contribution-date"
            type="date"
            className="form-control form-control-lg"
            value={data.date}
            onChange={actions.handleChangeDate}
            required
            max={MAX_DATE}
            min={data.lastOperationDate}
          />
        </div>
      </div>

      <UploadDocument
        label="AddDocumentOptional"
        inputLabel={data.file?.name || t('DragDocumentToUpload')}
        file={data.file}
        setFile={actions.handleChangeFile}
      />

      <InputTextArea
        id="contribution-comments"
        label={t('CommentsLabel')}
        value={data.comments}
        onChange={actions.handleChangeComments}
        maxLength={MAX_COMMENT_LENGTH}
        noResize
      />
    </>
  );
};

export default ContributionModalScriptureView;
